// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 34 ? "application" : chunkId) + "-" + {"34":"0601254b","650":"35f2549f"}[chunkId] + ".css";
};